var app = require('../index');

app.fn('account.showChangePasswordForm', function(e, el) {
	this.model.set('_page.showChangePasswordForm', true);
});

//Update billing info (address and/or credit card)
app.fn('account.updateBillingInfo', function(e, el) {
	e.preventDefault();

	//Validation
	//Use parsley for basic validation
	if (! $('#subscribe-form').parsley('validate') ) return false;
//	if ( $('input[name=planId]:checked').length == 0 ) {
//		alert('Please select a subscription plan');
//		return;
//	}

	//TEMP
	//TODO figure out how to conditionally require fields with parsley
	if ($('input[name=updateCreditCard]').prop('checked')) {
		var required = ['cardNumber', 'cvc', 'expMonth', 'expYear'];
		var valid = true;
		required.forEach(function(field) {
			if ($('#'+field).val()=='') {
				valid = false;
				return;
			}
		});
		if (!valid) {
			alert('Please fill out all your credit card information, or uncheck the "Update credit card" box.');
			return;
		}
	}

	var model = this.model;
	var user = model.get('_page.user');
	var address = user.address;

	if (!address.stateCode && !address.stateName) {
		alert('Please enter or select your state/province');
		return;
	}

	//if the user changed the email address on this form for whatever reason,
	//change the login email as well if they used their email to register (rather than Facebook, Google, etc.)
	//we don't want the confusion of multiple different email addresses...
	if (user.local) {
		user.local.email = user.email;
	}

	//store the country name in addition to the country code
	model.get('_page.countries').forEach(function(country) {
		if (country.code == address.countryCode) {
			address.countryName = country.name;
		}
	});

	//also store the state name
	//we only need to do this if there was a state dropdown for the selected country;
	//for countries without an auto-populated list of states, address.stateName was already bound
	if (address.stateCode) {
		model.get('_page.states').forEach(function(state) {
			if (state.code == address.stateCode) {
				address.stateName = state.name;
			}
		});
	}

	//TODO
	//IMPORTANT
	//check if email address already in system if entering email for first time or changing it

	// Save the user
	model.set('auths.' + user.id, user, function(err) {
		if (err) {
			alert('An error occurred saving your billing information. Please try again or contact us if the problem persists.');
			return;
		}

		if (model.get('_page.updateCreditCard')) {
			//Now that the user is saved, send the payment info to Stripe
			Stripe.card.createToken($('#subscribe-form'), stripeUpdateBillingInfoHandler);
		}
		else {
			alert('Your billing information was updated successfully.');
            window.location = '/account';
		}
	});
});

function stripeUpdateBillingInfoHandler(status, response) {
  var $form = $('#subscribe-form');

  if (response.error) {
    // Show the errors on the form
    $form.find('.payment-errors').text(response.error.message);
//    $('#btn-purchase').prop('disabled', false) //re-enable submit button
//        .html('Purchase Subscription');
  } else {
    // token contains id, last4, and card type
    var token = response.id;

    // Submit the form via AJAX so we can display any payment errors (like a card declined error)

	var formData = $form.serialize();
	//Add the Stripe token to be submitted with the rest of the form data
	formData += '&stripeToken='+token;

    var internalErrorMsg = 'An internal error occurred while attempting to update your information. Please try again or contact us if that does not resolve it.';

	$.ajax('/account/update-billing-info', {
		method: 'post',
		data: formData,
		dataType: 'json' //should get JSON back from the server
	})
	.done(function(data, textStatus, jqXHR) {
		if (data.success) {
			alert('Your billing information was updated successfully.');
			window.location = '/account';
		}
		else if (data.error) {
			showPaymentError(data.error.message || data.error || internalErrorMsg);
		}
		else showPaymentError(internalErrorMsg);
	})
	.error(function(jqXHR) {
		showPaymentError(internalErrorMsg);
	});

	function showPaymentError(msg) {
		$('#payment-errors').html(msg);
		//re-enable the submit button
//        $('#btn-purchase').prop('disabled', false) //re-enable submit button
//            .html('Purchase Subscription');
	}
  }
};